import axios from 'axios';
import config from '../../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../../core/modules/common/tools/URLTools';

const apiFetchPredesPlannedTransportAnomaliesDestinationDetails = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getPredesPlannedTransportAnomaliesDestinationDetails',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchPredesPlannedTransportAnomaliesDestinationDetails;
